<script setup>
import { computed, provide } from 'vue'
import { useToggle } from '@vueuse/core'
import { useApi } from '@provise/composables/api'
import { format } from 'date-fns'
import Modal from '@provise/components/mod.vue'
import Complaints from '@/views/complaints/list/table.vue'
import { commons } from '@provise/lib/transformer'

const model = defineModel()
const props = defineProps({
  self: {
    type: Number,
  },
})
const [showingComplaints, showComplaints] = useToggle(false)
const exclude = computed(() => {
  const res = (model.value || []).map(({ id }) => id)
  if (props.self) {
    res.push(props.self)
  }
  return res
})
const { model: categories } = useApi({
  url: 'request_category',
  query: { onPage: 100 },
  immediate: true,
  data: [],
  pick: d => (d.data || []).map(({ name, id }) => ({ name, id })),
})
const _relates = computed(() => {
  const rels = model.value || []
  const cats = categories.value

  return rels.map(rel => {
    let label = []
    const cat = cats.find(({ id }) => id == rel.request_category?.id)
    const medLabel = commons.medicineLabel(rel.medicine)

    if (cat) {
      label.push(cat.name)
    }
    label.push(medLabel)
    label.push(format(rel.date_created, 'P'))

    label = label.join(' ')
    return { ...rel, label }
  })
})
function onSelect(rel, mbs) {
  model.value = [...(model.value || []), rel]
  mbs.hide()
}
function onRm(rel) {
  const idx = model.value.findIndex(r => r.id == rel)
  const res = [...model.value]

  res.splice(idx, 1)
  model.value = res
}
provide('modalstack', true)
</script>
<template>
  <h6>
    Связанные события
    <button type="button" class="btn btn-link" @click="showComplaints()">
      <i class="bi bi-plus-circle" />
      Добавить
    </button>
  </h6>

  <div class="grid mb-3" v-if="_relates.length" style="--bs-columns: 3">
    <div
      class="d-flex align-items-center small bg-secondary p-1 rounded"
      v-for="rel of _relates"
      :key="rel.id"
    >
      <RouterLink :to="{ name: 'complaint.item', params: { id: rel.id } }" target="_blank" class="d-block">
        {{ rel.label }}
      </RouterLink>
      <button type="button" class="btn ms-auto text-danger align-self-center" @click="onRm(rel.id)">
        <i class="bi bi-trash" />
      </button>
    </div>
  </div>

  <Modal v-if="showingComplaints" #="{ mbs }" @hidden="showComplaints(false)">
    <Complaints @select="onSelect($event, mbs)" :exclude="exclude" />
  </Modal>
</template>
